import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setRetrospectiveDay({ commit }, days) {
    commit(types.SET_DAYS, days)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  setUserChecked({ commit }, data) {
    commit(types.SET_USER_CHECKED, data)
  },
  async setUserEmail({ commit, dispatch }, data) {
    await startLoading(dispatch, 'setUserEmail', () =>
      http.get('user/saveUserEmail', {
        params: data
      })
    )
    commit(types.SET_EMAIL, data)
  },
  setUser({ commit }, data) {
    commit(types.SET_USER, data)
  },
  syncNotitifySettings({ state }) {
    console.log('🌳 syncNotitifySettings', state.userNotifications)
    let username = state.user ? state.user.username : null
    let notifications = state.userNotifications ? state.userNotifications : null
    let event = new CustomEvent('notifySettingsEvent', {
      detail: { username, notifications }
    })
    window.dispatchEvent(event)
  },
  addUser({ commit }, data) {
    commit(types.ADD_USER, data)
  },
  updateUser({ commit }, data) {
    commit(types.UPDATE_USER, data)
  },
  resetUserNotifications({ commit }) {
    commit(types.RESET_USER_NOTIFICATIONS)
  },
  updateUserNotification({ commit }, data) {
    commit(types.UPDATE_USER_NOTIFICATION, data)
  },
  async getRoles({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'getRoles', () => http.get(`user/roles?firm=${firm}`))
    commit(types.SET_ROLES, r.data)
    return r.data
  },
  async getUser({ commit, dispatch }, username) {
    const r = await startLoading(dispatch, 'getUser', () =>
      http.get('user/profile', {
        params: {
          username: username
        }
      })
    )
    commit(types.SET_USER, r.data)
    return r.data
  },
  async getUserForChat({ commit, dispatch }, data) {
    let query = data.guid ? `guid=${data.guid}` : data.username ? `username=${data.username}` : null
    if (query) {
      const r = await startLoading(dispatch, 'getUserForChat', () => http.get(`user/userforChat?${query}`))
      commit(types.SET_USER, r.data)
      return r.data
    }
  },
  async getUserbyGuid({ commit, dispatch }, guid) {
    const r = await startLoading(dispatch, 'getUserbyGuid', () => http.get(`user/userByGuid?guid=${guid}`))
    commit(types.SET_USER, r.data)
    return r.data
  },
  async getUserBasic({ commit, dispatch }, username) {
    const r = await startLoading(dispatch, 'getUserBasic', () => http.get(`user/userBasic?username=${username}`))
    commit(types.SET_USER, r.data)
    return r.data
  },
  async getUsers({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getUsers', () =>
      http.get('user/users', {
        params: searchOptions
      })
    )
    commit(types.SET_USERS, r.data)
    return r.data
  },
  async verifyUsername({ commit, dispatch }, username) {
    const r = await startLoading(dispatch, 'verifyUsername', () => http.get(`user/verifyUsername?username=${username}`))
    return r.data
  },
  async saveUser({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveUser', () => http.post('user/saveUser', state.user))
    return r.data
  },
  async deleteUsers({ commit, state, dispatch }, users) {
    const r = await startLoading(dispatch, 'deleteUsers', () => http.post('user/deleteUsers', users))
    return r.data
  },
  async saveCredentials({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveCredentials', () => http.post('user/saveCredentials', data))
    return r.data
  },
  async updateUserParams({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateUserParams', () => http.post('user/updateUserParams', data))
    return r.data
  },
  async activateUsers({ commit, state, dispatch }, users) {
    const r = await startLoading(dispatch, 'activateUsers', () => http.post('user/activateUsers', users))
    for (let user of users) {
      var status = false
      if (user.token === '1') {
        status = true
      }
      commit(types.SET_USER_CHECKED, { username: user.username, isChecked: status })
    }
    return r.data
  },
  async getUserNotifications({ commit, dispatch }, user) {
    const r = await startLoading(dispatch, 'getUserNotifications', () => http.get(`user/userNotifications?user=${user}`))
    commit(types.SET_USER_NOTIFICATIONS, r.data)
    return r.data
  },
  async saveUserNotifications({ commit, state, dispatch }, data) {
    await dispatch('syncNotitifySettings')
    const r = await startLoading(dispatch, 'saveUserNotifications', () => http.post('user/saveUserNotifications', data))
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/users/actions.js